import React from 'react';
import { NFTContainer } from './NFTContainer';
const NFTView = () => {
  return <NFTContainer />;
};

export default NFTView;
